import { doc, updateDoc, setDoc, deleteDoc } from 'firebase/firestore'
import { ref } from 'vue'
import firebase from '../../firebase'
import { httpsCallable } from 'firebase/functions'
import updateDevice from '../composables/updateDevice'

// To update some fields of a document without overwriting the entire document.
// Doesn't work if the document doesn't already exist

const updateDocument = (collectionName, documentId) => {
  const updatePending = ref(false)
  const updateError = ref(null)

  const handlelUpdate = async (data, admin) => {
    try {
      updatePending.value = true
      await updateDoc(doc(firebase.db, collectionName, documentId), data)

      if (collectionName === 'devices' && data.deviceType) {
        await updateDevice().updateDeviceBasedOnId(documentId, data.deviceType)
      }

      if (admin && (collectionName === 'users' || collectionName === 'doctors' || collectionName === 'admin')) { 
        const updateFirebaseUser = httpsCallable(firebase.functions, 'updateFirebaseUser')

        try {
          const updatedData = {}
          if (data.email) updatedData.email = data.email
          if (data.firstName && data.lastName) updatedData.displayName = `${data.firstName} ${data.lastName}`

          if (Object.keys(updatedData).length) {
            await updateFirebaseUser({ uid: documentId, ...updatedData })
          }
        } catch (err) {
          updateError.value = err.message
          return
        }
      }
      updatePending.value = false
    } catch (error) {
      updateError.value = error.message
      updatePending.value = false
      console.log(error)
    }
  }

  return { updateError, updatePending, handlelUpdate }
}

// If the document does not exist, it will be created. If the document does exist, fieds 
// will be merged.

const createDocument = (collectionName) => {
  const createPending = ref(false)
  const createError = ref(null)

  const handleCreate = async (documentId, data) => {
    try {
      createPending.value = true
      await setDoc(doc(firebase.db, collectionName, documentId), data, { merge: true })
      createPending.value = false
    } catch (error) {
      createError.value = error.message
      createPending.value = false
      console.log(error)
    }
  }

  return { createError, createPending, handleCreate }
}

const deleteDocument = (collectionName) => {
  const deleteError = ref('')
  const deletePending = ref(false)

  const handleDelete = async (documentId, admin) => {
    try {
      deletePending.value = true

      if (admin && (collectionName === 'users' || collectionName === 'doctors' || collectionName === 'admin')) {
        const deleteFirebaseUser = httpsCallable(firebase.functions, 'deleteFirebaseUser')

        try {
          await deleteFirebaseUser({ uid: documentId })
        } catch (err) {
          deleteError.value = err.message
          return
        }
      }
      await deleteDoc(doc(firebase.db, collectionName, documentId))
      deletePending.value = false
      deleteError.value = ''
    } catch (error) {
      deleteError.value = error.message
    }
  }
  return { deleteError, deletePending, handleDelete }
}

export { updateDocument, createDocument, deleteDocument }
